import { algorand } from "./algorand.js"
import { bitcoin } from "./bitcoin.js"
import { cardano } from "./cardano.js"
import { dash } from "./dash.js"
import { dogecoin } from "./dogecoin.js"
import { arbitrum, arc, base, bsc, ethereum, matic, optimism, robinhood } from "./evmV2.js"
import { filecoin } from "./filecoin.js"
import { litecoin } from "./litecoin.js"
import { ripple } from "./ripple.js"
import { tron } from "./tron.js"

export const networksConfig = {
    algorand,
    arbitrum,
    arc,
    base,
    bitcoin,
    bsc,
    cardano,
    dash,
    dogecoin,
    ethereum,
    filecoin,
    litecoin,
    matic,
    optimism,
    ripple,
    robinhood,
    tron,
}

export const blockchains = [
    algorand,
    arbitrum,
    arc,
    base,
    bitcoin,
    bsc,
    cardano,
    dash,
    dogecoin,
    ethereum,
    filecoin,
    litecoin,
    matic,
    optimism,
    ripple,
    robinhood,
    tron,
].filter((blockchain) => blockchain.check)

export const blockchainsDedup: Array<{name: string; title: string}> = Object.values(
    blockchains.reduce((acc, blockchain) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
        acc[blockchain.name] = blockchain
        return acc
    }, {})
)
